import gql from 'graphql-tag'
import { Course } from '~/graphql/fragments/course.js'

export const USER_LOGIN = gql`
  mutation userLogIn($email: String!, $password: String!, $client: String!) {
    userLogIn(email: $email, password: $password, client: $client) {
      sessionTokens {
        userToken
      }
      errors {
        key
        message
      }
    }
  }
`
export const UPDATE_USER_PERSONAL_PROFILE = gql`
  mutation userUpdatePersonalProfile($staffId: Int, $profile: UserUpdatePersonalProfileInput!) {
    userUpdatePersonalProfile(staffId: $staffId, profile: $profile) {
      id
      name
      email
      designation
      dateJoin
      nric
      employeeId
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      academyMinutesPerDay
      academyActivedAt
      nric
      employeeId
      organisationTitleId
      manager {
        id
        media {
          url
        }
        name
      }
      media {
        id
        url
        fileName
      }
    }
  }
`
export const ADD_USER_WORK_EXPERIENCE = gql`
  mutation userAddWorkExp($work: WorkExperienceInput!, $staffId: Int) {
    userAddWorkExp(work: $work, staffId: $staffId) {
      id
      title
      organisation
      location
      isHighlight
      isCurrently
      startDate
      endDate
      description
      medias {
        id
        url
        fileName
      }
    }
  }
`
export const UPDATE_USER_WORK_EXPERIENCE = gql`
  mutation userUpdateWorkExp($workExperienceId: Int!, $work: WorkExperienceInput!, $staffId: Int) {
    userUpdateWorkExp(workExperienceId: $workExperienceId, work: $work, staffId: $staffId) {
      id
      title
      organisation
      location
      isHighlight
      isCurrently
      startDate
      endDate
      description
      medias {
        id
        url
        fileName
      }
    }
  }
`
export const REMOVE_USER_WORK_EXPERIENCE = gql`
  mutation userRemoveWorkExps($workExperienceIds: [Int]) {
    userRemoveWorkExps(workExperienceIds: $workExperienceIds)
  }
`

export const ADD_USER_TRAINING_RECORD = gql`
  mutation userAddTrainingRecord($trainingRecord: TrainingRecordInput!, $staffId: Int) {
    userAddTrainingRecord(trainingRecord: $trainingRecord, staffId: $staffId) {
      id
      courseTitle
      courseProvider
      trainingMode
      startDate
      endDate
      trainingTime
      description
      trainingCost
      sponsoredBy
      grantBy
      verifiedAt
      verifiedBy
      verifiedName
      medias {
        id
        fileName
        url
      }
    }
  }
`
export const UPDATE_USER_TRAINING_RECORD = gql`
  mutation userUpdateTrainingRecord($trainingRecordId: Int!, $trainingRecord: TrainingRecordInput!, $staffId: Int) {
    userUpdateTrainingRecord(trainingRecordId: $trainingRecordId, trainingRecord: $trainingRecord, staffId: $staffId) {
      id
      courseTitle
      courseProvider
      trainingMode
      startDate
      endDate
      trainingTime
      description
      trainingCost
      sponsoredBy
      grantBy
      verifiedAt
      verifiedBy
      verifiedName
      medias {
        id
        fileName
        url
      }
    }
  }
`
export const REMOVE_USER_TRAINING_RECORD = gql`
  mutation userRemoveTrainingRecords($trainingRecordIds: [Int]) {
    userRemoveTrainingRecords(trainingRecordIds: $trainingRecordIds)
  }
`

export const UPDATE_USER_PROFILE = gql`
  mutation academyStaffUpdateProfile($schoolId: Int!, $profile: PersonalProfileInput!) {
    academyStaffUpdateProfile(schoolId: $schoolId, profile: $profile) {
      courses {
        ...Course
      }
    }
  }
  ${Course}
`
